import { useField } from "formik";
import { InputHTMLAttributes } from "react";
import styles from "./InputField.module.scss";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  type?: string;
  optional?: boolean;
  // TODO: these props should be improved
  dark?: boolean;
  darkest?: boolean;
}

// form input that connects to a formik form
const InputField: React.FC<Props> = ({
  name,
  label,
  type = "text",
  optional,
  dark,
  darkest,
  ...rest
}) => {
  const [field, _meta, _helpers] = useField(name);

  return (
    <div className={styles.container}>
      <input
        data-testid={`input-${name}`}
        className={styles.input}
        // TODO: this darker variant can reference a css variable
        type={type}
        placeholder={label}
        aria-label={label}
        style={
          darkest
            ? { background: "#050505" }
            : dark
            ? { background: "#171717" }
            : undefined
        }
        {...field}
        {...rest}
      />
      {optional && <span className={styles.note}>Optional</span>}
    </div>
  );
};

export default InputField;
